import React, { useContext } from 'react';
import { FormContext } from '../../context/EquipmentFormContext';
import { LuShieldAlert } from 'react-icons/lu';
import { FiCheck } from 'react-icons/fi';

export default function Step4() {
  const { formData, setFormData } = useContext(FormContext);

  const toggleCompliance = (key) => {
    setFormData(prev => ({
      ...prev,
      compliance: { ...prev.compliance, [key]: !prev.compliance[key] }
    }));
  };

  const checklist = [
    { id: 'pat', label: "Requires PAT (Electrical Test)" },
    { id: 'iot', label: "Temperature Monitoring (IoT)" },
    { id: 'gas', label: "Gas Related" },
    { id: 'statutory', label: "Statutory Inspection" },
    { id: 'calibration', label: "Calibration Required" },
    { id: 'fire', label: "Fire Safety Related" }
  ];

  return (
    <div className="bg-white rounded-xl border border-slate-100 p-6 shadow-sm">
      <div className="flex items-start space-x-4 mb-4">
        <div className="p-2 bg-blue-600 rounded-lg text-white"><LuShieldAlert className="w-5 h-5 stroke-[2.5]" /></div>
        <div>
          <div className="flex items-center space-x-2">
            <span className="text-xs font-bold bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded">4</span>
            <h2 className="text-base font-bold text-indigo-950">Compliance Requirements</h2>
          </div>
          <p className="text-xs text-slate-500 mt-0.5">Select which compliance requirements apply to this equipment.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 pt-2">
        {checklist.map((item) => {
          const isChecked = formData.compliance[item.id];
          return (
            <label key={item.id} onClick={() => toggleCompliance(item.id)} className={`flex items-start p-3 border rounded-xl cursor-pointer select-none transition-colors ${isChecked ? 'border-blue-200 bg-blue-50/20' : 'border-slate-200 hover:bg-slate-50'}`}>
              <div className="relative flex items-center mt-0.5">
                <div className={`w-4 h-4 border rounded flex items-center justify-center text-white transition-colors ${isChecked ? 'bg-blue-600 border-blue-600' : 'border-slate-300 bg-white'}`}>
                  {isChecked && <FiCheck className="w-3 h-3" />}
                </div>
              </div>
              <span className="text-[11px] font-semibold text-slate-700 ml-2.5 leading-tight">{item.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
